import { useGetCoPilotConfig } from '@/pages/shared/hooks/useCoPilotConfig';
import { useUserOrganizationId } from '@/pages/shared/hooks/useUserOrganizationId';
import { isNullish } from '@/utils/booleans';

export const useIsOrganizationOnboarded = (organizationIdArg?: string) => {
  const orgId = useUserOrganizationId();
  const organizationId = organizationIdArg ?? orgId;

  const onboardingConfiguration = useGetCoPilotConfig(organizationId)?.data;

  return (
    !isNullish(onboardingConfiguration.profile) ||
    !isNullish(onboardingConfiguration.industry) ||
    onboardingConfiguration.goals.length > 0 ||
    onboardingConfiguration.goals_compliance.length > 0 ||
    !isNullish(onboardingConfiguration.goals_context)
  );
};
